import { render, staticRenderFns } from "./ToolboxArboMenu.vue?vue&type=template&id=5297273e&"
import script from "./ToolboxArboMenu.vue?vue&type=script&lang=js&"
export * from "./ToolboxArboMenu.vue?vue&type=script&lang=js&"
import style0 from "./ToolboxArboMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports